import * as DocumentTypeOptions from './DocumentTypeOptions';
import * as DocumentTypes from './DocumentTypes';

export const generateDocumentsData = (documents) => {
  let data = {
    id: documents.id,
    doc_category: documents.category,
    quick_action: documents.category,
    data_id: 1,
  };

  switch (documents.category) {
    case DocumentTypes.RESUME:
      data.file_name = DocumentTypeOptions.RESUME.file_name;
      data.required = DocumentTypeOptions.RESUME.required;
      data.file = '';
      return data;

    case DocumentTypes.REFERENCES:
      data.file_name = DocumentTypeOptions.REFERENCES.file_name;
      data.required = DocumentTypeOptions.REFERENCES.required;
      data.file = '';
      return data;

    case DocumentTypes.CERTIFICATIONS:
      data.file_name = DocumentTypeOptions.CERTIFICATIONS.file_name;
      data.required = DocumentTypeOptions.CERTIFICATIONS.required;
      data.file = '';
      return data;

    case DocumentTypes.COVER_LETTER:
      data.file_name = DocumentTypeOptions.COVER_LETTER.file_name;
      data.required = DocumentTypeOptions.COVER_LETTER.required;
      data.file = '';
      return data;

    case DocumentTypes.PROFILE_PICTURE:
      data.file_name = DocumentTypeOptions.PROFILE_PICTURE.file_name;
      data.required = DocumentTypeOptions.PROFILE_PICTURE.required;
      data.file = '';
      return data;

    case DocumentTypes.PORTFOLIO:
      data.file_name = DocumentTypeOptions.PORTFOLIO.file_name;
      data.required = DocumentTypeOptions.PORTFOLIO.required;
      data.file = '';
      return data;

    default:
      data.file_name = DocumentTypeOptions.OTHERS.file_name;
      data.required = DocumentTypeOptions.OTHERS.required;
      data.file = '';
      return data;
  }
};

export const generateDocumentsDataV2 = (documents) => {
  const data = {
    id: documents.id,
    doc_category: documents.category,
    quick_action: documents.category,
    data_id: 1,
    isMulti: false,
    files: [],
  };

  switch (documents.category) {
    case DocumentTypes.RESUME:
      data.file_name = DocumentTypeOptions.RESUME.file_name;
      data.required = DocumentTypeOptions.RESUME.required;
      return data;

    case DocumentTypes.REFERENCES:
      data.file_name = DocumentTypeOptions.REFERENCES.file_name;
      data.required = DocumentTypeOptions.REFERENCES.required;
      return data;

    case DocumentTypes.CERTIFICATIONS:
      data.file_name = DocumentTypeOptions.CERTIFICATIONS.file_name;
      data.required = DocumentTypeOptions.CERTIFICATIONS.required;
      data.isMulti = true;
      return data;

    case DocumentTypes.COVER_LETTER:
      data.file_name = DocumentTypeOptions.COVER_LETTER.file_name;
      data.required = DocumentTypeOptions.COVER_LETTER.required;
      return data;

    case DocumentTypes.PROFILE_PICTURE:
      data.file_name = DocumentTypeOptions.PROFILE_PICTURE.file_name;
      data.required = DocumentTypeOptions.PROFILE_PICTURE.required;
      return data;

    case DocumentTypes.PORTFOLIO:
      data.file_name = DocumentTypeOptions.PORTFOLIO.file_name;
      data.required = DocumentTypeOptions.PORTFOLIO.required;
      return data;

    default:
      data.file_name = DocumentTypeOptions.OTHERS.file_name;
      data.required = DocumentTypeOptions.OTHERS.required;
      data.isMulti = true;
      return data;
  }
};
